<template>
<ob-popover trigger="click" :options="{placement: 'bottom', modifiers: { offset: { offset: '87px,0px' } }}">
    <div class="popper">
        <div class="popper-content-holder">
            <div v-for="(log, index) in cLogs" :key="index">
                <p class="section-title">to {{log.SharedTo.Name}}</p>
                <div class="clearfix">
                    <div class="pull-left" style="margin-right: 20px;">
                        <div class="form-group">
                            <label class="control-label">Email Address</label>
                            <p class="form-control-static">{{NAOrValue(log.SharedTo, 'Email')}}</p>
                        </div>
                    </div>
                    <div class="pull-right">
                        <div class="form-group">
                            <label class="control-label">Shared Date</label>
                            <p class="form-control-static">{{ log.CreatedDate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <span slot="reference" class="popover-trigger">
        <i class="fa fa-users"></i> <u>Shared</u>
    </span>

</ob-popover>
</template>
<script>
export default {
    props: ["logs"],
    computed: {
        cLogs() {
            return __.orderBy(this.logs, ['CreatedDateTime'], ['desc']);
        }
    }
}
</script>
<style scoped>
.popper {
    text-align: left;
    padding: 10px;
}
.popper-content-holder {
    max-height: 150px;
    overflow-y: auto;
}
.popover-trigger {
    color: #4A90E2;
    cursor: pointer;
}
.section-title {
    color: #4A90E2;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 600;
}
.control-label {
    font-size: 11px;
    color: #8695A5;
}
.form-control-static {
    font-size: 12px;
    color: #475259;
    font-weight: 600;
    padding: 0;
}
.form-group {
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/SharedLog.vue